import { getTheme, Text } from '@fluentui/react';
import React from 'react';
import { ReactElement } from 'react';
import { ContentPreviews } from '../rules/ContentPreviews';
import { titleStylesAccessComponentsClass } from '../SettingsStyles';
import { BaseTab } from './BaseTab';

interface ContentPreviewsTabProps {
  subjectType: string;
}

export const ContentPreviewsTab = (props: ContentPreviewsTabProps): ReactElement => {
  const { fonts, palette } = getTheme();

  // TODO: ask about this, why is this boolean here? should we simply not show the tab in this case?
  const isContentPreviewSubjectType =
    props.subjectType !== 'LocationUnsafe' && props.subjectType !== 'Location' && props.subjectType !== 'Audio';

  return isContentPreviewSubjectType ? (
    <BaseTab>
      <ContentPreviews displayName={props.subjectType} />
    </BaseTab>
  ) : (
    <BaseTab>
      <Text className={titleStylesAccessComponentsClass(palette, fonts)} variant={'xLargePlus'}>
        {`Your subject type: ${props.subjectType}, does not support content previews.`}
      </Text>
    </BaseTab>
  );
};
